import { connect } from 'react-redux';
import { SeoLink as SeoLinkBase } from './SeoLink';
import { navigateTo } from 'store/state/router/actions';

const SeoLink = connect(null, { navigate: navigateTo })(SeoLinkBase);

export default SeoLink;
